<template>
  <div class="card">
    <MessageRow 
      v-for="message, i in messages"
      :key="i"
      :index="i"
      :message="message"
      :group="group"
    />
  </div>
</template>

<script>
import MessageRow from './ChatExampleMessageRow'
export default {
  props: {
    messages: Array,
    group: String,
  },
  components: {
    MessageRow
  }
}
</script>

<style lang="scss" scoped>

.card {
  width: 343px;
  height: 311px;
  background-color: #F5F5F5;
  border-radius: 10px;
  box-shadow: 10px 12px 29px rgba(0, 0, 0, 0.12);
  padding: 25px 24px 0;
  overflow: hidden;
  @media screen and (max-width: 768px) {
    width: 437px;
    height: 418px;
  }
  @media screen and (max-width: 540px) {
    width: 100%;
    padding: 25px 24px;

    height: auto;
  }
  @media screen and (max-width: 480px) {
    padding: 19px 18px;
  }
}



</style>